//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const customerLoginStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
    padding: 16,
  },
  mainDiv: {
    padding: 16,
    margin: "auto",
    maxWidth: 800,
  },
  backBtnGrid: {
    marginTop: 16,
  },
  submitBtnGrid: {
    marginTop: 16,
    textAlign: "right",
  },
  btn: {
    textTransform: "capitalize",
    fontSize: 18,
    fontWeight: "bold",
  },
  toastCss: {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  },
}));

export const loginStyles = makeStyles(() => ({
  loginText: {
    fontSize: 40,
    color: "#fff",
    fontFamily: "segoe-ui",
    padding: 25,
  },
  inputMainDiv: {
    padding: "0 25px",
  },
  emailInputDiv: {
    padding: "10px 0",
  },
  emailInputIconBtn: {
    marginRight: "-12px",
  },
  emailInputIcon: {
    color: "#fff",
    fontSize: 30,
  },
  forgotMailText: {
    color: "#fff",
    fontSize: 16,
    textAlign: "right",
  },
  passwordInputDiv: {
    padding: "10px 0",
  },
  passwordInputIconBtn: {
    color: "#fff",
  },
  passwordInputIcon: {
    color: "#fff",
  },
  forgotPasswordText: {
    color: "#fff",
    fontSize: 16,
    textAlign: "right",
    cursor: "pointer",
    textDecoration: "underline",
    float: "right"
  },
  loginBtnDiv: {
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 10,
    padding: "40px 25px 0px 25px",
  },
  loginBtn: {
    backgroundColor: "#005EAC",
    color: "#fff",
    width: "100%",
    height: 50,
    fontSize: 22,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#005EAC",
    },
  },
  newAccountText: {
    padding: "30px 25px",
    color: "#fff",
    fontSize: 16,
    cursor: "pointer",
    float:"left"
  },
  customerLoginBtnDiv: {
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "40px 25px 0px 25px",
  },
  customerLoginBtn: {
    backgroundColor: "#005EAC",
    color: "#fff",
    width: "100%",
    height: 50,
    lineHeight: 1.5,
    fontSize: 22,
    textTransform: "capitalize",
    marginBottom: 50,
    "&:hover": {
      backgroundColor: "#005EAC",
    },
    "@media (min-width: 600px) and (max-width: 768px)": {
      height: 70,
    },
  },
  sharePage: {
    margin: "30px 0 0 0",
  },
}));

export const signUpEmailStyles = makeStyles((theme) => ({
  signUpText: {
    fontSize: 50,
    color: "#fff",
    fontFamily: "segoe-ui",
    padding: 25,
  },
  inputMainDiv: {
    padding: "20px 25px",
  },
  emailInputIconBtn: {
    marginRight: "-12px",
  },
  emailInputIcon: {
    color: "#fff",
  },
  btnDiv: {
    padding: "40px 25px",
  },
  btn: {
    backgroundColor: "#005EAC",
    color: "#fff",
    width: "100%",
    height: 50,
    fontSize: 22,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#005EAC",
    },
  },
}));

export const verifyOTPStyles = makeStyles((theme) => ({
  verifyOTPText: {
    fontSize: 50,
    color: "#fff",
    fontFamily: "segoe-ui",
    padding: "25px 30px",
  },
  verifyOTPIcon: {
    fontSize: "40px",
    cursor: "pointer",
  },
  inputMainDiv: {
    padding: "20px 30px",
  },
  otpInputIconBtn: {
    marginRight: "-12px",
  },
  otpInputIcon: {
    color: "#fff",
  },
  btnDiv: {
    padding: "40px 25px 40px 30px",
  },
  btn: {
    backgroundColor: "#005EAC",
    color: "#fff",
    width: "100%",
    height: 55,
    fontSize: 22,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#005EAC",
    },
  },
  resentOTPMainDiv: {
    padding: "40px 30px ",
  },
  resendText: {
    color: "#D3D3D3",
    fontSize: 16,
  },
  resendLink: {
    textDecoration: "underline",
    fontSize: 18,
    color: "#fff",
    cursor: "pointer",
  },
}));

export const signUpDetailsStyles = makeStyles((theme) => ({
  userText: {
    fontSize: 40,
    color: "#fff",
    fontFamily: "segoe-ui",
    padding: "15px 30px",
  },
  backArrowIcon: {
    fontSize: "30px",
  },
  inputMainDiv: {
    padding: "0 30px",
  },
  inputRow: {
    padding: "10px 0",
  },
  roleInput: {
    width: "100%",
  },
  passwordInputIcon: {
    color: "#fff",
  },
  passwordValidateIcon: {
    verticalAlign: "middle",
  },
  termsTextParent: {
    padding: "15px",
  },
  termsText: {
    color: "#D3D3D3",
    fontSize: 14,
  },
  btnDiv: {
    padding: "0px 25px 0px 30px",
    "@media (max-width: 600px)": {
      padding: "0px 25px 20px 30px",
    },
  },
  btn: {
    backgroundColor: "#005EAC",
    color: "#fff",
    width: "100%",
    height: 55,
    fontSize: 22,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#005EAC",
    },
  },
}));

export const resetPasswordStyles = makeStyles((theme) => ({
  resetPasswordText: {
    fontSize: 50,
    color: "#fff",
    fontFamily: "segoe-ui",
    padding: "25px 30px",
  },
  inputMainDiv: {
    padding: "20px 30px",
  },
  inputRow: {
    padding: "10px 0",
  },
  inputIcon: {
    color: "#fff",
  },
  btnDiv: {
    padding: "30px 30px",
  },
  btn: {
    backgroundColor: "#005EAC",
    color: "#fff",
    width: "100%",
    height: 55,
    fontSize: 22,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#005EAC",
    },
  },
  error: {
    display: "none"
  },
  errorValid: {
    letterSpacing: "1px",
    color: "green",
    opacity: 1,
    display: "flex",
    alignItems: "center",
    marginTop: 5,
    background: "#fff",
    padding: 10,
    width: '90%',
    marginLeft: 30,
    borderRadius: 10
  },
  errorInvalid: {
    letterSpacing: "1px",
    color: "red",
    opacity: 1,
    display: "flex",
    alignItems: "center",
    marginTop: 5,
    background: "#ccc",
    padding: 10,
    width: '90%',
    marginLeft: 30,
    borderRadius: 10
  },
}));

export const forgotPasswordStyles = makeStyles((theme) => ({
  forgotPasswordText: {
    fontSize: 40,
    color: "#fff",
    fontFamily: "segoe-ui",
    padding: 25,
  },
  inputMainDiv: {
    padding: "20px 30px",
  },
  inputIconBtn: {
    marginRight: "-12px",
  },
  inputIcon: {
    color: "#fff",
    fontSize: 30,
  },
  btnDiv: {
    padding: "40px 30px",
  },
  btn: {
    backgroundColor: "#005EAC",
    color: "#fff",
    width: "100%",
    height: 55,
    fontSize: 22,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#005EAC",
    },
  },
  arrowBtn: {
    fontSize: "40px",
    cursor: "pointer",
  },
}));

export const consentStyles = makeStyles((theme) => ({
  divText: {
    fontSize: 30,
    fontFamily: "segoe-ui!important",
    textAlign: "center",
    backgroundColor: "#dddddd",
  },
  divSubText: {
    fontSize: 22,
    fontFamily: "segoe-ui!important",
    textAlign: "left",
    padding: 20,
  },
  gepdivSubText: {
    fontSize: 22,
    fontFamily: "segoe-ui!important",
    textAlign: "left",
    padding: 20,
    backgroundColor:"rgb(235 163 169)",
    fontWeight:"bold",
  },
  card: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "75%",
    marginBottom: 20,
  },
  gepcard: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "63%",
    marginBottom: 20,
  },
  gepcancelBtn: {
    fontSize: "16px",
    fontFamily: "Segoe UI, sans-serif",
    textAlign: "center",
    margin: "10px auto",
    height: "40px",
    width: "150px",
    border: "2px solid #888",
    borderRadius: "6px",
    padding: "8px 12px",
    //backgroundColor: "#f5f5f5",
    cursor: "pointer",
    display: "block", 
    backgroundColor:"rgb(235 163 169)",
    fontWeight:"bold",
  },
   cancelBtn: {
    float: "left",
    color: "rgb(55 126 185)",
    backgroundColor: "#dddddd",
    fontWeight: "bold",
    margin: 10,
    "&:hover": {
      backgroundColor: "#dddddd",
    },
  },
  enrollBtn: {
    float: "right",
    color: "#fff",
    backgroundColor: "#4472c4",
    fontWeight: "bold",
    margin: 10,
    "&:hover": {
      backgroundColor: "#4472c4",
    },
  },
  mainDiv: {
    textAlign: "center",
  },
}));
